const state = {
  storeName: {
    // storeNameArr : [FR,DE_s,DE,EE,MB,ED]
    FR: true,
    // EE: false,
    // DE_s: false,
  }
}

export default {
  namespaced: true,
  state,
}